export const getInitialState = (): any => ({
  taskStoppageData: {},
  taskStoppageStatus: 0
});
